import React from "react";
import DataAccessHelper from "../Helper/DataAccessHelper.js";
import DateHelpers from '../Helper/DateHelpers.js';
import AddTransaction from '../Routes/AddTransaction.js'
import ViewTransactionHistory from '../Components/ViewTransactionHistory.js'
import { useNavigate } from "react-router-dom";
import RegistrationInfo from "./RegistrationInfo.js";
import { useState, useEffect } from "react";
import '../Styles/AccountDetails.scss';


function GroupAccountDetails({ reservationInfo, setViewGroupAccountDetailsVisibility }) {
   console.log("queried registration", reservationInfo)
   const [accountInfo, setAccountInfo] = useState({})

   async function GetAccountInformation() {
      const response = await fetch('/getaccountinformation', {
         method: 'POST',
         headers: { "Content-Type": "application/json" },
         body: JSON.stringify({
            accountId: reservationInfo.group_account_id
         })
      })
      const accountInfo = await response.json();
      console.log("account Info", accountInfo.data.account[0])
      setAccountInfo(accountInfo.data.account[0])
   }

   useEffect(() => {
      GetAccountInformation()
   }, []);


   return (
      <div className="GroupAccountDetailsContainer">
         <div className="GroupAccountDetailsContent">
            <div className="GroupAccountDetailsHeading">
               Accountholder Details
            </div>
            <div className="GroupAccountDetailsFields">
               <div className="GroupAccountDetailsCloseButtonContainer">
                  {/* <button onClick={s setViewGroupAccountDetailsVisibility(false)}>
                     Close
                  </button> */}
               </div>
            </div>
         </div>
      </div>
   )
}
export default GroupAccountDetails